let chatWs = 'ws://118.24.111.189:15674/ws';


if (process.env.NODE_ENV === 'production') {
    chatWs = 'wss://hlwyy.hyd-imi.com/ws';
}


const setter = {
    name: '互联网医院',
    dataName: 'hyd-hlwyy',
    baseURL: '/official',
    tokenName: 'x-hyd-token',
    userInfo: 'hyd-hlwyy-userInfo',
    organInfo: 'hyd-hlwyy-organInfo',
    txMapKey: 'OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77',
    chatWs: chatWs,
    imagePath: {
        homeSwiper: '/hydImage/indexSwiper/'
    }
}

export default setter